// @flow
import * as React from 'react';

import isEmpty from 'lodash/isEmpty';
import { useParams } from 'react-router-dom';

import { View } from 'reshaped';

import { selectOrder, selectPrepaid } from '@gandi/billing';

import { selectCartTotal } from '@gandi/cart';

import { selectCurrentId } from '@gandi/redux-sharing';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { useCurrency } from 'src/hooks/useCurrency';

import { useCartSummaryContext } from '../../../context/CartSummary';

import { DiscountLine } from './DiscountLine';
import { PrepaidInfo } from './Total/PrepaidInfo';
import { Remaining } from './Total/Remaining';
import TotalRow from './Total/TotalRow';
import TotalTaxRow from './Total/TotalTaxRow';

export function CartSummaryPriceBreakdown(): React.MixedElement | null {
  const { flushPrepaid } = useCartSummaryContext();
  const params = useParams<{ orderId: string }>();
  const orderId = parseInt(params.orderId, 10);
  const sharingId = useAppSelector(selectCurrentId);

  const order = useAppSelector(state => selectOrder(state, { orderId }));

  const currency = useCurrency();
  const total = useAppSelector(selectCartTotal);

  const prepaid = useAppSelector(state => selectPrepaid(state, { sharingId }));

  if (isEmpty(total) || !currency) return null;

  const { afterTaxes } = total;
  const taxes = orderId ? order?.taxes : total.taxes;

  const actualTaxes = Array.isArray(taxes)
    ? taxes.filter(tax => tax.name !== 'notax')
    : [];

  const priceAfterTaxes = orderId ? order?.price_after_taxes : afterTaxes;

  return (
    <View gap={2} width="100%">
      {actualTaxes.length > 0 &&
        actualTaxes.map(tax => (
          <TotalTaxRow key={tax.name} tax={tax} currency={currency} />
        ))}
      <DiscountLine />
      <TotalRow amount={priceAfterTaxes} currency={currency} />
      {flushPrepaid && prepaid && (
        <>
          <PrepaidInfo prepaid={prepaid} />
          <Remaining
            prepaid={prepaid}
            total={priceAfterTaxes}
            currency={currency}
          />
        </>
      )}
    </View>
  );
}
